document.addEventListener('DOMContentLoaded', () => {
    const slider = $('.js-hero-slider');

    slider && slider.slick({
        fade: true,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        mobileFirst: true,
        rtl: m.about.rtl,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    arrows: true,
                    nextArrow: '<svg class="slick-next" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.645 14L19.355 17.29L30.0416 28L19.355 38.71L22.645 42L36.645 28L22.645 14Z" fill="#8B90A1"/></svg>',
                    prevArrow: '<svg class="slick-prev" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33.355 14L36.645 17.29L25.9584 28L36.645 38.71L33.355 42L19.355 28L33.355 14Z" fill="#8B90A1"/></svg>',
                }
            }
        ]
    });
});
